// extracted by mini-css-extract-plugin
module.exports = {"tablet-up":"(min-width: calc(768 * 1px))","rating":"RatingItem_rating___NCgx","col":"RatingItem_col__1Yb3p","desc":"RatingItem_desc__10HXN"};